import { render, staticRenderFns } from "./ShortMessagePush.vue?vue&type=template&id=b2e09c4c&"
import script from "./ShortMessagePush.vue?vue&type=script&lang=js&"
export * from "./ShortMessagePush.vue?vue&type=script&lang=js&"
import style0 from "./ShortMessagePush.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports